import { ariaGetControlledElement } from '@vo/js/utils/aria'

export default (function () {
    const openButtons = document.querySelectorAll('[data-site-switch-popup-trigger]')
    const closeButton = document.querySelector('[aria-controls="site-switch-popup"]')
    const popup = ariaGetControlledElement(closeButton)

    if (!openButtons.length || !closeButton || !popup) return

    const popupInner = popup.querySelector('#site-switch-popup-inner')

    const openPopup = () => {
        document.body.classList.add('overflow-hidden')
        popup.classList.remove('opacity-0', 'invisible', 'pointer-events-none')
    }

    const closePopup = () => {
        document.body.classList.remove('overflow-hidden')
        popup.classList.add('opacity-0', 'invisible', 'pointer-events-none')
    }

    openButtons.forEach(button => {
        button.addEventListener('click', () => openPopup())
    })

    closeButton.addEventListener('click', () => closePopup())

    document.addEventListener('click', (event) => {
        const exceptions = ['#newsletter-popup-inner', '#language-switch-popup-inner', '#site-switch-popup-inner', '[data-site-switch-popup-trigger]', '#CybotCookiebotDialog', '#CybotCookiebotDialogBodyUnderlay', '#onetrust-consent-sdk']
        let closeAllowed = true

        exceptions.forEach(exception => {
            if (event.target.closest(exception)) {
                closeAllowed = false
            }
        })

        if (closeAllowed) {
            closePopup()
        }
    })
})
